import React from 'react';
import TextField from '@mui/material/TextField';
import PhoneInput from 'react-phone-input-2';
import 'react-phone-input-2/lib/style.css';
import { useStyles } from './styles';
import { Box, Typography } from '@mui/material';
import useIsMobile from 'hooks/useIsMobile';

const DefaultProps = {
  showInformation: true,
  countryProp: 'us',
  marginRightProp: 0.62,
  autoFormatProp: true,
  customBgColor: '',
};

export default function WhatsappPhoneTextField(properties) {
  const {
    label,
    onChange,
    value,
    error,
    helperText,
    countryProp,
    showInformation,
    marginRightProp,
    autoFormatProp,
    customBgColor,
    ...phoneInputProperties
  } = properties;
  const classes = useStyles({ customBgColor });
  const isMobile = useIsMobile();

  return (
    <>
      <Box ml={isMobile ? 1 : 0} mr={isMobile ? 0 : marginRightProp}>
        <TextField
          variant="standard"
          {...phoneInputProperties}
          label={label}
          fullWidth
          placeholder=""
          error={error}
          helperText={helperText}
          InputLabelProps={{
            shrink: true,
          }}
          InputProps={{
            required: false,
            autoFocus: true,
            inputComponent: PhoneInput,
            inputProps: {
              containerClass: classes.inputContainerClass,
              inputClass: classes.inputClass,
              buttonClass: classes.buttonClass,
              dropdownClass: classes.dropdownClass,
              searchClass: classes.searchClass,
              placeholder: '(__) _____-____',
              country: countryProp,
              disableCountryCode: false,
              value: value,
              onChange: onChange,
              autoFormat: autoFormatProp,
            },
          }}
        />
      </Box>

      {showInformation && (
        <Typography variant="body2" component="p" className={classes.textConfidential}>
          Your information is kept confidential according to our Privacy Policy.
        </Typography>
      )}
    </>
  );
}

WhatsappPhoneTextField.defaultProps = DefaultProps;
